import { Container } from "./styled";

export interface InputProps
  extends Omit<React.ComponentProps<typeof Container>, "size"> {
  onValueChange: (value: string) => void;
  size?: "sm" | "md" | "lg" | "xl";
}

interface InputComponent extends React.FC<InputProps> {
  Container: typeof Container;
}

/** A text input form control. */
const Input: InputComponent = ({
  onValueChange,
  onChange,
  size = "md",
  ...props
}) => {
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (onChange) onChange(event);
    onValueChange(event.target.value);
  }
  return <Container data-size={size} {...props} onChange={handleChange} />;
};

Input.Container = Container;

export { Input };
